"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var axios_1 = __importDefault(require("axios"));
var SHOW_MAPS_SIZE = 20;
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentPageNumber = 1;
        _this.hasMoreMaps = true;
        _this.isLoading = false;
        return _this;
    }
    default_1.prototype.loadMoreMaps = function () {
        var _this = this;
        if (this.debounceTimer)
            clearTimeout(this.debounceTimer);
        this.debounceTimer = window.setTimeout(function () { return _this.executeLoadMore(); }, 300);
    };
    default_1.prototype.executeLoadMore = function () {
        return __awaiter(this, void 0, Promise, function () {
            var mapsListApiUrl, data, dataMaps, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLoading)
                            return [2 /*return*/];
                        if (!this.hasMoreMaps) {
                            this.resetMaps();
                            return [2 /*return*/];
                        }
                        this.setLoadingState(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        mapsListApiUrl = this.data.get('urlValue');
                        if (!mapsListApiUrl) {
                            throw new Error('Missing urlValue on maps-list-lazy-load controller');
                        }
                        return [4 /*yield*/, axios_1.default.get(mapsListApiUrl, {
                                params: { page: this.currentPageNumber }
                            })];
                    case 2:
                        data = (_a.sent()).data;
                        dataMaps = data.maps || [];
                        if (dataMaps.length > 0) {
                            this.appendMaps(dataMaps);
                            this.currentPageNumber++;
                            this.hasMoreMaps = data.has_more;
                        }
                        else {
                            this.hasMoreMaps = false;
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Failed to load maps:', error_1);
                        this.hasMoreMaps = false;
                        return [3 /*break*/, 5];
                    case 4:
                        this.updateButton();
                        this.setLoadingState(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    default_1.prototype.appendMaps = function (maps) {
        var _this = this;
        maps.forEach(function (_a) {
            var label = _a.label;
            var span = document.createElement('span');
            span.textContent = label;
            var li = document.createElement('li');
            li.className = 'category-LinkList_Cell';
            li.appendChild(span);
            _this.mapListTarget.appendChild(li);
        });
    };
    default_1.prototype.resetMaps = function () {
        var _a;
        var allItems = this.mapListTarget.querySelectorAll('li');
        var totalItems = allItems.length;
        for (var i = totalItems - 1; i >= SHOW_MAPS_SIZE; i--) {
            (_a = allItems[i]) === null || _a === void 0 ? void 0 : _a.remove();
        }
        this.currentPageNumber = 1;
        this.hasMoreMaps = true;
        this.updateButton();
    };
    default_1.prototype.setLoadingState = function (loading) {
        this.isLoading = loading;
        if (this.hasLoadMoreButtonTarget) {
            this.loadMoreButtonTarget.disabled = loading;
            if (loading) {
                this.loadMoreButtonTarget.textContent = '読み込み中...';
            }
        }
    };
    default_1.prototype.updateButton = function () {
        if (!this.hasLoadMoreButtonTarget)
            return;
        var loadMoreButtonElement = this.loadMoreButtonTarget;
        var loadMoreButtonIconElement = loadMoreButtonElement.previousElementSibling;
        if (this.hasMoreMaps) {
            loadMoreButtonElement.textContent = 'もっと見る';
            loadMoreButtonIconElement === null || loadMoreButtonIconElement === void 0 ? void 0 : loadMoreButtonIconElement.classList.replace('jirafficon-arrow-up', 'jirafficon-arrow-down');
        }
        else {
            loadMoreButtonElement.textContent = '閉じる';
            loadMoreButtonIconElement === null || loadMoreButtonIconElement === void 0 ? void 0 : loadMoreButtonIconElement.classList.replace('jirafficon-arrow-down', 'jirafficon-arrow-up');
        }
    };
    default_1.targets = ['mapList', 'loadMoreButton'];
    return default_1;
}(stimulus_1.Controller));
exports.default = default_1;
